const she = {
  FORMAT_ERROR: {
    message: 'A planilha não está no formato padrão',
    field: null,
    code: 'SHE_1'
  },
  WRONG_NUMBER_OF_SHEETS: {
    message: 'A planilha deve conter apenas uma aba',
    field: null,
    code: 'SHE_2'
  },
  WRONG_FIRST_LINE: {
    message: 'A primeira linha da planilha está fora do padrão',
    field: null,
    code: 'SHE_3'
  },
  HEADERS_LENGTH_ERROR_MESSAGE: {
    message: 'O número de colunas está diferente do modelo padrão',
    field: null,
    code: 'SHE_4'
  },
  HEADER_NOT_MAPPED: {
    message: 'O cabeçalho de uma ou mais colunas não é o esperado',
    field: null,
    code: 'SHE_5'
  },
  REQUIRED_HEADER_NOT_PROVIDED: {
    message: 'Um ou mais cabeçalhos não foram preenchidos',
    field: null,
    code: 'SHE_6'
  },
  UNABLE_TO_PROCESS_FILE: {
    message: 'Não foi possível processar o arquivo',
    field: null,
    code: 'SHE_7'
  },
  INVALID_FILE_EXTENSION: {
    message: 'A extensão do arquivo não é válida',
    field: null,
    code: 'SHE_8'
  }
};

module.exports = she;
